
const Link = ({mouseOverEvent, mouseOutEvent}) => {
    return(
         <index onMouseOut={mouseOutEvent} onMouseOver={mouseOverEvent} />
    );
};
export default Link;